var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5109 1.38944L11.0101 0.88907C10.8913 0.770294 10.699 0.770294 10.5802 0.88907L6.00002 5.45562L1.41987 0.88907C1.30101 0.770294 1.1088 0.770294 0.989931 0.88907L0.489174 1.38944C0.370308 1.50822 0.370308 1.70028 0.489174 1.81906L5.78505 7.11091C5.90392 7.22968 6.09613 7.22968 6.215 7.11091L11.5109 1.81906C11.6297 1.70028 11.6297 1.50822 11.5109 1.38944Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.f6435b0ce99926a794f2435cbb8a3a85.svg";
export { ForwardRef as ReactComponent };